import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { TimeTrackingEntry } from '../../data/types';

export type TimeTrackingState = {
    timeEntries: TimeTrackingEntry[],
}

export const useTimeTrackingState = () => {
    const timeTrackingState = useSelector((state: RootState | any) => state.timeTrackingEntries as TimeTrackingState);
    return timeTrackingState;
}

// Define the initial state using that type
const initialState: TimeTrackingState = {
    timeEntries: [],
}

export const timeTrackingSlice = createSlice({
    name: 'timeTrackingEntries',
    initialState: initialState,
    reducers: {
        setTimeTrackingEntriesAction: (state, action: PayloadAction<TimeTrackingEntry[]>) => {
            state.timeEntries = action.payload;
        },
        addOrReplaceTimeTrackingEntryAction: (state, action: PayloadAction<TimeTrackingEntry>) => {
            const existingIndex = state.timeEntries.findIndex((entry: TimeTrackingEntry) => entry?.entryId === action.payload.entryId);
            if (existingIndex >= 0) {
                state.timeEntries[existingIndex] = action.payload;
            } else {
                state.timeEntries.push(action.payload);
            }
        },
        deleteTimeTrackingEntryAction: (state, action: PayloadAction<string>) => {
            state.timeEntries = state.timeEntries.filter((x) => x.entryId !== action.payload);
        },
    }
})

export const { addOrReplaceTimeTrackingEntryAction, setTimeTrackingEntriesAction, deleteTimeTrackingEntryAction } = timeTrackingSlice.actions;
export default timeTrackingSlice.reducer;